define('TescoMobile_Checkout/js/action/upgrade/submit-upgrade',['jquery', 'mage/storage', 'Magento_Checkout/js/model/url-builder', 'Magento_Checkout/js/model/quote', 'Magento_Checkout/js/model/error-processor', 'Magento_Checkout/js/model/full-screen-loader', 'Magento_Customer/js/model/customer'], function ($, storage, urlBuilder, quote, errorProcessor, fullScreenLoader, customer) {
  'use strict';

  return function (messageContainer, itemId, mpn) {
    let serviceUrl;
    if (customer.isLoggedIn()) {
      serviceUrl = urlBuilder.createUrl('/carts/mine/save-upgrade/:itemId/:mpn', {
        itemId: itemId,
        mpn: mpn
      });
    } else {
      serviceUrl = urlBuilder.createUrl('/guest-carts/:cartId/save-upgrade/:itemId/:mpn', {
        cartId: quote.getQuoteId(),
        itemId: itemId,
        mpn: mpn
      });
    }
    fullScreenLoader.startLoader();
    return storage.post(serviceUrl).fail(response => {
      errorProcessor.process(messageContainer, response);
      $('body').trigger('dl-payg-migrate-pin-validate-fail');
    }).always(() => fullScreenLoader.stopLoader());
  };
});

